import { useParams } from "react-router-dom";
import { PageTitle } from "../modules/PageHeaders";
import RoleForm from "./modules/RoleForm";
import { useGetCompanyRoleQuery } from "../../../store/admin/settings/roleSlice";
import RoleFormSkeletonLoader from "../../../components/Common/RoleFormSkeletonLoader";

const EditRole = () => {
  const { roleId } = useParams();
  const { data: role, isLoading, error } = useGetCompanyRoleQuery(roleId, {
    skip: !roleId,
  });

  return (
    <section className="px-2 px-lg-4 min-vh-100">
      <div className="py-1"></div>
      <div className="mb-4">
        <PageTitle title={"Edit Role"} />
      </div>
      {isLoading && <RoleFormSkeletonLoader />}
      {error && (
        <p className="text-danger">
          {error?.data?.message || "Unable to load role"}
        </p>
      )}
      {role && !role.is_system && (
        <RoleForm initialRole={role} roleId={roleId} />
      )}
      {role?.is_system && (
        <p className="text-muted">
          The Super Admin role cannot be edited. It always mirrors your
          organisation&apos;s plan modules.
        </p>
      )}
    </section>
  );
};

export default EditRole;
